import { Component, inject, signal, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ConfigurationService } from '@services/configuration.service';

export type NotificationType = 'info' | 'success' | 'warning' | 'error';

@Component({
  selector: 'app-notification',
  imports: [],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class NotificationComponent implements OnInit {
  private configService = inject(ConfigurationService);
  message = signal('');
  type = signal<NotificationType>('warning');
  visible = signal(false);

  ngOnInit() {
    const cfg = this.configService.config();
    const notification = cfg?.notification;

    if (notification?.enabled) {
      this.visible.set(notification.enabled);
      this.type.set(notification?.type);
      this.message.set(notification.message);
    }
  }

  hide() {
    this.visible.set(false);
  }

}
